import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  underlined: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    paddingBottom: theme.spacing(1),
  },
}));

export default function VehiclesForm(props) {
  const { control } = useFormContext();
  const classes = useStyles();

  return (
    <Box {...props}>
      <Typography className={classes.underlined} gutterBottom variant="h5">
        VEHICLES
      </Typography>
      <FormGroup aria-label="position">
        <Controller
          name="sku.vehicles:motorbike"
          control={control}
          as={
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Motorbike"
            />
          }
        />
        <Controller
          name="sku.vehicles:car"
          control={control}
          as={
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Cars"
            />
          }
        />
        <Controller
          name="sku.vehicles:ride_on_lawnmower"
          control={control}
          as={
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="Ride-on Lawnmower"
            />
          }
        />
      </FormGroup>
    </Box>
  );
}
